import { render, staticRenderFns } from "./AllCart.vue?vue&type=template&id=490fe0ac"
import script from "./AllCart.vue?vue&type=script&lang=js"
export * from "./AllCart.vue?vue&type=script&lang=js"
import style0 from "./AllCart.vue?vue&type=style&index=0&id=490fe0ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports